import React, { useState } from "react";
import { AlertModal } from "../../../../../setup/alert/swalAlert";
import { alertIconType } from "../../../../../setup/alert/iconTypes";
import * as authActions from "../../../AxiosRtk/Auth";
import { isEmpty } from "lodash";
import { useDispatch, useSelector } from "react-redux";
import useCrypto from "../../../../customHooks/crypto";
import useLangTranslation from "../../../../customHooks/languageProvider";
import { useHistory } from "react-router-dom";
import LoadingIndicator from "../../../../../setup/Loader/LoaderIndicator";
import { setShowInfo, setShowMessage } from "../../../AxiosRtk/successMessage";
// import KidoProject from '../../../../../assets/images/logo.png';
// import { Link } from 'react-router-dom/cjs/react-router-dom';

const CreateNewPassword = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { getLangTranslation } = useLangTranslation();
  const { encryptRequest } = useCrypto();
  const [pwdType, setPwdType] = useState({
    password: "password",
    confirmPassword: "password",
  });
  const [inputData, setInputData] = useState({
    password: { value: "", error: "" },
    confirmPassword: { value: "", error: "" },
  });
  const { resetPassword, removeItem } = authActions;
  const { forgotPwd } = useSelector(({ auth }) => auth);
  const [loader, setLoader] = useState(false);

  function handleInputChange(e) {
    const { name, value } = e.target;
    setInputData({
      ...inputData,
      [name]: {
        value,
        error: "",
      },
    });
  }

  function handleTogglePassword(type) {
    if (type === "password") {
      setPwdType({
        ...pwdType,
        password: pwdType?.password === "password" ? "text" : "password",
      });
    } else if (type === "confirmPassword") {
      setPwdType({
        ...pwdType,
        confirmPassword:
          pwdType?.confirmPassword === "password" ? "text" : "password",
      });
    }
  }

  function handleSave() {
    if (
      isEmpty(inputData?.password?.value) ||
      isEmpty(inputData?.confirmPassword?.value)
    ) {
      const pwd = inputData?.password?.value;
      const confirmPwd = inputData?.confirmPassword?.value;
      setInputData({
        password: {
          value: pwd,
          error: isEmpty(pwd) ? "PASSWORD_IS_REQUIRED" : "",
        },
        confirmPassword: {
          value: confirmPwd,
          error: isEmpty(confirmPwd) ? "CONFIRM_PWD_REQUIRED_ERR" : "",
        },
      });
      return;
    } else if (
      inputData?.password?.value?.length < 8 &&
      inputData?.password?.value?.length > 16
    ) {
      {
        /* AlertModal("PWD_8_TO_16_CHAR_LONG", alertIconType.infoIcon, true);*/
      }

      dispatch(
        setShowInfo({
          showInfo: true,
          defaultMessage: "Password must be 8 to 16 characters long",
          message: "PWD_8_TO_16_CHAR_LONG",
        })
      );
      return;
    } else if (
      inputData?.password?.value !== inputData?.confirmPassword?.value
    ) {
      setInputData({
        ...inputData,
        confirmPassword: {
          value: inputData?.confirmPassword?.value,
          error: "NEW_PASSWORD_PASSWORD_NOT_MATCH_ERROR",
        },
      });
      return;
    } else {
      setLoader(true);
      resetPassword(
        forgotPwd?.forgotPwdToken,
        encryptRequest(inputData?.password?.value)?.content
      )
        .then((res) => {
          {
            /* AlertModal(res?.data?.message, alertIconType.successIcon);*/
          }
          dispatch(
            setShowMessage({
              showMessage: true,
              defaultMessage: res?.data?.message,
              message: res?.data?.message,
            })
          );
          setTimeout(() => {
            dispatch(removeItem("forgotPwd"));
            history.push("/auth/login");
          }, 2000);
        })
        .catch((err) => {
          AlertModal(err?.response?.data?.message, alertIconType.errorIcon);
        })
        .finally(() => {
          setLoader(false);
        });
    }
  }

  return (
    <>
      <div className="container">
        <div className="auth-wrapper">
          <div className="auth-inner">
            <h2 className="text-center mb-6">
              {getLangTranslation("CREATE_NEW_PASSWORD", "create a new password ")}
            </h2>
            <div className="mb-6">
              <label htmlFor="password" className="form-label text-capitalize">
                {getLangTranslation(
                  "NEW_PASSWORD_ET_TEXT",
                  "Enter new password"
                )}
              </label>
              <div className="input-group">
                <input
                  className="form-control"
                  type={pwdType?.password}
                  name="password"
                  placeholder={getLangTranslation(
                    "NEW_PASSWORD_ET_TEXT",
                    "Enter new password"
                  )}
                  value={inputData?.password?.value}
                  onChange={handleInputChange}
                />
                <span
                  className="input-group-text pt-cursor"
                  onClick={() => handleTogglePassword("password")}
                >
                  {pwdType?.password === "password" ? (
                    <i className="fa fa-eye-slash" id="togglePassword"></i>
                  ) : (
                    <i className="fa fa-eye" id="togglePassword"></i>
                  )}
                </span>
              </div>
              {inputData?.password?.error && (
                <label className="field-error">
                  {getLangTranslation(inputData?.password?.error)}
                </label>
              )}
            </div>
            <div className="mb-6">
              <label htmlFor="password" className="form-label text-capitalize">
                {getLangTranslation(
                  "NEW_PASSWORD_CONFIRM_ET_TEXT",
                  "Confirm password"
                )}
              </label>
              <div className="input-group">
                <input
                  className="form-control"
                  type={pwdType?.confirmPassword}
                  name="confirmPassword"
                  placeholder={getLangTranslation(
                    "NEW_PASSWORD_CONFIRM_ET_TEXT",
                    "Confirm password"
                  )}
                  value={inputData?.confirmPassword?.value}
                  onChange={handleInputChange}
                />
                <span
                  className="input-group-text pt-cursor"
                  onClick={() => handleTogglePassword("confirmPassword")}
                >
                  {pwdType?.confirmPassword === "password" ? (
                    <i className="fa fa-eye-slash" id="togglePassword"></i>
                  ) : (
                    <i className="fa fa-eye" id="togglePassword"></i>
                  )}
                </span>
              </div>
              {inputData?.confirmPassword?.error && (
                <label className="field-error">
                  {getLangTranslation(inputData?.confirmPassword?.error)}
                </label>
              )}
            </div>
            <div className="d-grid">
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleSave}
                disabled={loader}
              >
                {loader ? (
                  <LoadingIndicator width={100} height={40} />
                ) : (
                  <span className="btn-upper-case">
                    {getLangTranslation("SAVE", "Save")}
                  </span>
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CreateNewPassword;
